/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest(value) {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequestFromJSON(json) {
    return FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'],
    };
}
export function FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequestToJSON(json) {
    return FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesDocumentsGetAllDocumentsWithVersionsGetAllDocumentsWithVersionsRequest.js.map